import React, { FunctionComponent, useMemo } from 'react'

import styled from 'styled-components'

import translate from '@i18n'
import useSportCompetitorsList from '@hooks/useSportCompetitorsList'
import { SportCompetitorsListProps } from '@widgets/SportCompetitorsList'
import Placeholder from '@components/LayoutTabs/SubsectionReusableComponents/Placeholder'
import SportCompetitor from '@components/SportCompetitor'
import { SvgIconName } from '@components/SvgIcon/types'

const StyledListWrapper = styled.div``
const StyledList = styled.ul`
  list-style: none;
  padding: 0;
`

const SportCompetitorsList: FunctionComponent<SportCompetitorsListProps> = ({
  seasonId,
  typeOfSport,
}) => {
  const {
    data: competitorsListData,
    error,
    isFetched,
  } = useSportCompetitorsList({
    typeOfSport,
    seasonId,
  })
  const hasNonEmptyData =
    competitorsListData && competitorsListData.items.length > 0

  const sportCompetitorsListContent = useMemo(() => {
    if (hasNonEmptyData) {
      return (
        <>
          {competitorsListData.items.map((competitor) => (
            <SportCompetitor
              key={competitor.sportradarId}
              competitor={competitor}
            />
          ))}
        </>
      )
    } else {
      const placeholderMessage = error
        ? {
            iconName: 'user-robot-xmarks-solid' as SvgIconName,
            title: translate('network.error.title'),
            text: translate('network.error.text'),
          }
        : isFetched
          ? {
              iconName: 'calendar-clock' as SvgIconName,
              title: translate('sports.emptyData.title'),
              text: translate('sports.emptyData.text'),
            }
          : undefined

      return placeholderMessage ? (
        <Placeholder
          iconName={placeholderMessage.iconName}
          title={placeholderMessage.title}
          text={placeholderMessage.text}
        />
      ) : null
    }
  }, [competitorsListData?.items, error, hasNonEmptyData, isFetched])

  return (
    <StyledListWrapper>
      <StyledList>{sportCompetitorsListContent}</StyledList>
    </StyledListWrapper>
  )
}

export default SportCompetitorsList
